"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phase = void 0;
var Phase;
(function (Phase) {
    Phase[Phase["Unknown"] = 0] = "Unknown";
    Phase[Phase["Phase 1"] = 1] = "Phase 1";
    Phase[Phase["Phase 2"] = 2] = "Phase 2";
    Phase[Phase["Phase 3"] = 3] = "Phase 3";
    Phase[Phase["Phase 4"] = 4] = "Phase 4";
    Phase[Phase["Phase 5"] = 5] = "Phase 5";
})(Phase = exports.Phase || (exports.Phase = {}));
//# sourceMappingURL=Phase.js.map